import { render } from "./Keyboard.vue?vue&type=template&id=60ce5a4e"
import script from "./Keyboard.vue?vue&type=script&lang=js"
export * from "./Keyboard.vue?vue&type=script&lang=js"

import "./Keyboard.vue?vue&type=style&index=0&id=60ce5a4e&lang=scss"
script.render = render

export default script